import { render } from "./CrosstabChart.vue?vue&type=template&id=3b0c7f25&scoped=true&ts=true"
import script from "./CrosstabChart.vue?vue&type=script&lang=ts"
export * from "./CrosstabChart.vue?vue&type=script&lang=ts"

import "./CrosstabChart.vue?vue&type=style&index=0&id=3b0c7f25&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b0c7f25"]])

export default __exports__